import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import style from "./styles/header.module.scss"

import logo from "../images/logo.svg"

const Header = ({ siteTitle, hideMenu }) => (
    <header className={style.component}>
      <img src={logo} className={style.logo} alt={siteTitle} />
      <nav className={style.navigation}>
        {!hideMenu ?
         <ul>
           <li><a href="#why">Why RES</a></li>
           <li><a href="#projects">Projects</a></li>
           <li><a href="#testimonials">Testimonials</a></li>
           <li><a href="#team">Team</a></li>
           <li><a href="#contact">Contact Info</a></li>
         </ul> :
         <ul>
           <li><Link to="/">Go Back</Link></li>
         </ul>}
      </nav>
    </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header

